// vdb-free-gift-banner.js
// Gestione banner regalo gratuito: soglia, popup, 1 solo regalo, fasi guidate dal carrello reale + reload condizionali in pagina carrello
(function () {
  if (window.__vdbFreeGiftBannerLoaded) return;
  window.__vdbFreeGiftBannerLoaded = true;

  // === CONFIG: handle dei prodotti omaggio (fallback sicuro) ===
  var GLOBAL_FREE_GIFT_HANDLES = [
  'omaggio-vino-del-giorno'
];

  // Flag di debug (puoi mettere a false quando hai finito i test)
  var __VDB_GIFT_DEBUG = true;

  function giftDebug() {
    if (!__VDB_GIFT_DEBUG || typeof console === 'undefined') return;
    try {
      console.log.apply(console, arguments);
    } catch (e) {}
  }

  function ready(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  ready(function () {
    var wrappers = document.querySelectorAll('[data-vdb-gift-banner="true"]');
    if (!wrappers.length) return;
    for (var i = 0; i < wrappers.length; i++) {
      initBanner(wrappers[i]);
    }
  });

  function initBanner(wrapper) {
    if (!wrapper || !wrapper.dataset) return;

    var dataset = wrapper.dataset;

    var giftThreshold = toNumber(dataset.giftThreshold);
    var currentTotal = toNumber(dataset.currentTotal);

    var variantId1 = dataset.giftVariant1 || '';
    var variantId2 = dataset.giftVariant2 || '';

    // Handle omaggi passati dal Liquid
    var giftHandle1 = dataset.giftHandle1 || '';
    var giftHandle2 = dataset.giftHandle2 || '';

    var currencyCode = dataset.currencyCode || detectCurrency();
    var moneyFormat = parseCurrencyFormat(dataset.currencyFormat) || '{{ amount }}';

    var locale = (dataset.locale || (document.documentElement && document.documentElement.lang) || 'en')
      .toLowerCase();

    // CODICE MERCATO (es. IT, US...) per decidere lingua principale
    var marketCode = (dataset.market || '').toUpperCase();

    var initialGiftInCart = (dataset.giftInCart || '').toLowerCase() === 'true';

    // Elementi banner
    var textEl = wrapper.querySelector('#vdb-gift-banner__text');
    var subtextEl = wrapper.querySelector('#vdb-gift-banner__subtext');
    var progressBar = wrapper.querySelector('.vdb-gift-banner__progress-bar');
    var progressFill = wrapper.querySelector('#vdb-gift-banner__progress-fill');
    var ctaButton = wrapper.querySelector('#vdb-gift-banner__button');

    // Elementi popup
    var popup = document.getElementById('vdb-gift-popup');
    var popupOverlay = document.getElementById('vdb-gift-popup__overlay');
    var popupClose = document.getElementById('vdb-gift-popup__close');
    var popupAdd = document.getElementById('vdb-gift-popup__add');
    var popupHeading = popup ? popup.querySelector('.vdb-gift-popup__heading') : null;
    var originalPopupHeading = popupHeading ? popupHeading.textContent : '';
    var giftOptions = popup
      ? Array.prototype.slice.call(popup.querySelectorAll('.vdb-gift-option'))
      : [];

    if (!progressBar || !progressFill || !textEl || !subtextEl || !ctaButton || !popup || !popupOverlay || !popupAdd) {
      return;
    }

// Pulisce i testi delle card:
// - se il nome del produttore è nel titolo, lo rimuove
// - tronca eventuale "Regalo" / "Gift" alla fine del titolo
function normalizeGiftCardTexts() {
  if (!giftOptions || !giftOptions.length) return;

  for (var i = 0; i < giftOptions.length; i++) {
    var option = giftOptions[i];
    var titleEl = option.querySelector('.vdb-gift-option__title');
    var vendorEl = option.querySelector('.vdb-gift-option__vendor');
    if (!titleEl) continue;

    var titleText = (titleEl.textContent || '').trim();
    var vendorText = vendorEl ? (vendorEl.textContent || '').trim() : '';

    // 1) Rimuovi il produttore dal titolo se è ripetuto
    if (titleText && vendorText) {
      var lowerTitle = titleText.toLowerCase();
      var lowerVendor = vendorText.toLowerCase();

      var idx = lowerTitle.indexOf(lowerVendor);
      if (idx > -1) {
        titleText = titleText.slice(0, idx).replace(/[\s\-–—]+$/g, '');
      }
    }

    // 2) Tronca eventuale "Regalo" / "Gift" alla fine del titolo
    //    (es. "Barolo DOCG Regalo" → "Barolo DOCG")
    titleText = titleText.replace(/\s*[-–—]?\s*(regalo|gift)\s*$/i, '');

    if (titleText) {
      titleEl.textContent = titleText;
    }
  }
}


// Normalizza subito le card (funziona sia per IT che per EN)
normalizeGiftCardTexts();



    // ▶︎ Copy ora dipende da marketCode (IT = italiano, altri = inglese)
    var copy = resolveCopy(locale, marketCode);

    // ID varianti omaggio (dal dataset + runtime)
    var giftVariantIds = [];
    if (variantId1) giftVariantIds.push(String(variantId1));
    if (variantId2 && variantId2 !== variantId1) giftVariantIds.push(String(variantId2));

    // Handle omaggio dal dataset + fallback globale
    var giftHandles = [];
    if (giftHandle1) giftHandles.push(String(giftHandle1).trim());
    if (giftHandle2 && giftHandle2 !== giftHandle1) giftHandles.push(String(giftHandle2).trim());
    for (var gh = 0; gh < GLOBAL_FREE_GIFT_HANDLES.length; gh++) {
      if (giftHandles.indexOf(GLOBAL_FREE_GIFT_HANDLES[gh]) === -1) {
        giftHandles.push(GLOBAL_FREE_GIFT_HANDLES[gh]);
      }
    }

    // Stato interno
    var lastTotalPrice = currentTotal;
    var hasGiftInCart = initialGiftInCart;
    var isPopupVisible = false;
    var selectedGiftVariantId = null;
    var autoRemoving = false;
    var currentGiftVariantId = null;
    var enforcingSingleGift = false;
    var isChangeMode = false;
    var isConfirmedMode = false;

    // Anti race-condition /cart.js
    var cartRequestId = 0;
    var lastAppliedCartRequestId = 0;

    // Tracciamento fase banner (1/2/3) per reload su passaggio a fase 1
    var lastPhase = null;

    giftDebug('INIT BANNER', {
      threshold: giftThreshold,
      currentTotal: currentTotal,
      variantId1: variantId1,
      variantId2: variantId2,
      giftHandle1: giftHandle1,
      giftHandle2: giftHandle2,
      giftHandles: giftHandles,
      initialGiftInCart: initialGiftInCart
    });

    // --- HELPER FASI ---
    function handlePhaseChange(newPhase, context) {
      if (newPhase == null) return;
      if (lastPhase === newPhase) return;

      giftDebug('PHASE CHANGE', {
        from: lastPhase,
        to: newPhase,
        context: context
      });

      // Se siamo in carrello e passiamo da fase 2 o 3 a fase 1 → reload
      if (isOnCartPage() && (lastPhase === 2 || lastPhase === 3) && newPhase === 1) {
        try {
          window.location.reload();
        } catch (e) {}
        return;
      }

      lastPhase = newPhase;
    }

    // --- Riconoscimento se una line_item è un omaggio ---
    function itemIsGift(item) {
      if (!item) return false;

      var variantId = item.id || item.variant_id;
      var handle =
        item.handle ||
        item.product_handle ||
        (item.product && item.product.handle);

      var handleStr = handle ? String(handle).trim() : '';
      var vIdStr = variantId ? String(variantId) : '';

      var isByHandle = !!(handleStr && giftHandles.indexOf(handleStr) !== -1);
      var isByVariant = !!(vIdStr && giftVariantIds.indexOf(vIdStr) !== -1);

      if (isByHandle && !isByVariant && vIdStr) {
        giftVariantIds.push(vIdStr);
        isByVariant = true;
      }

      var result = isByHandle || isByVariant;

      giftDebug('itemIsGift?', {
        title: item.title,
        id: variantId,
        handle: handleStr,
        quantity: item.quantity,
        isByVariant: isByVariant,
        isByHandle: isByHandle,
        result: result
      });

      return result;
    }

    function cartHasGift(cart) {
      var items = (cart && Array.isArray(cart.items)) ? cart.items : [];
      for (var i = 0; i < items.length; i++) {
        if (itemIsGift(items[i])) return true;
      }
      return false;
    }

    // Max 1 omaggio in tutto il carrello
    function enforceSingleGiftInCart(cart, totalPrice) {
      if (giftThreshold > 0 && totalPrice < giftThreshold) return;

      var items = Array.isArray(cart.items) ? cart.items : [];
      var totalGiftQty = 0;
      var firstGiftVariantIdFound = null;
      var giftVariantIdsFound = [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (!itemIsGift(item)) continue;

        var vId = item.id || item.variant_id;
        if (!vId) continue;

        var qty = item.quantity || 0;
        totalGiftQty += qty;

        var vIdStr = String(vId);
        if (!firstGiftVariantIdFound) firstGiftVariantIdFound = vIdStr;
        if (giftVariantIdsFound.indexOf(vIdStr) === -1) {
          giftVariantIdsFound.push(vIdStr);
        }
      }

      if (totalGiftQty <= 1) return;
      if (!giftVariantIdsFound.length) return;

      giftDebug('enforceSingleGiftInCart → found multiple gifts', {
        totalGiftQty: totalGiftQty,
        giftVariantIdsFound: giftVariantIdsFound,
        firstGiftVariantIdFound: firstGiftVariantIdFound
      });

      if (copy && copy.qtyWarning) {
        alert(copy.qtyWarning);
      }

      var updates = {};
      for (var j = 0; j < giftVariantIdsFound.length; j++) {
        updates[giftVariantIdsFound[j]] = 0;
      }
      if (firstGiftVariantIdFound) {
        updates[firstGiftVariantIdFound] = 1;
      }

      enforcingSingleGift = true;

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (res) {
          return res && typeof res.json === 'function'
            ? res.json().catch(function () { return null; })
            : null;
        })
        .then(function () {
          enforcingSingleGift = false;
          fetchCartAndUpdate();

          // Reload per riallineare le qty visibili in pagina carrello
          if (isOnCartPage()) {
            try {
              window.location.reload();
            } catch (e) {}
          }
        })
        .catch(function () {
          enforcingSingleGift = false;
        });
    }

    // Hook rete /cart/*
    function hookNetworkForCartUpdates() {
      if (window.__vdbCartNetworkHooked) return;
      window.__vdbCartNetworkHooked = true;

      var _fetch = window.fetch;
      if (_fetch) {
        window.fetch = function () {
          var args = arguments;
          var req = args[0];
          var url = (typeof req === 'string') ? req : (req && req.url) || '';
          var method = ((args[1] && args[1].method) || (req && req.method) || 'GET').toUpperCase();

          return _fetch.apply(this, arguments).then(function (resp) {
            try {
              var path = (url || '').split('?')[0];
              if (method !== 'GET' && /\/cart\/(add|update|change|clear)(\.js)?$/.test(path)) {
                giftDebug('HOOK fetch → detected cart change', { method: method, url: url });
                setTimeout(fetchCartAndUpdate, 80);
              }
            } catch (e) {}
            return resp;
          });
        };
      }

      var XHR = window.XMLHttpRequest;
      if (!XHR) return;

      function PatchedXHR() {
        var xhr = new XHR();
        var url = '', method = 'GET';

        var origOpen = xhr.open;
        xhr.open = function (m, u) {
          method = (m || 'GET').toUpperCase();
          url = u || '';
          origOpen.apply(xhr, arguments);
        };

        xhr.addEventListener('loadend', function () {
          try {
            var path = (url || '').split('?')[0];
            if (method !== 'GET' && /\/cart\/(add|update|change|clear)(\.js)?$/.test(path)) {
              giftDebug('HOOK XHR → detected cart change', { method: method, url: url });
              setTimeout(fetchCartAndUpdate, 80);
            }
          } catch (e) {}
        });

        return xhr;
      }
      window.XMLHttpRequest = PatchedXHR;
    }

    // Label iniziali
    ctaButton.textContent = copy.ctaLabel;
    popupAdd.textContent = copy.addButtonLabel;

    // Layout fisso top + padding body
    function measureAndLockPosition() {
      var height = wrapper.offsetHeight || 56;
      document.documentElement.style.setProperty('--vdb-banner-height', height + 'px');
      document.body.classList.add('vdb-banner-padding');
    }
    measureAndLockPosition();
    window.addEventListener('resize', debounce(measureAndLockPosition, 200));
    // Re-measure whenever the banner's height changes (e.g. after async text is set)
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(debounce(measureAndLockPosition, 50)).observe(wrapper);
    }

    // Logica opzioni popup
    for (var gi = 0; gi < giftOptions.length; gi++) {
      (function (option) {
        var optionVariantId = option.getAttribute('data-variant-id');
        if (!optionVariantId) {
          option.classList.add('is-disabled');
          option.setAttribute('aria-disabled', 'true');
          option.setAttribute('tabindex', '-1');
          return;
        }

        option.addEventListener('click', function (event) {
          if (event && event.target && event.target.closest && event.target.closest('[data-product-link]')) {
            return;
          }
          selectGift(option);
        });

        option.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectGift(option);
          }
        });
      })(giftOptions[gi]);
    }

    function selectGift(option) {
      if (!option) return;
      for (var i = 0; i < giftOptions.length; i++) {
        giftOptions[i].classList.remove('selected');
      }
      option.classList.add('selected');
      selectedGiftVariantId = option.getAttribute('data-variant-id');
      popupAdd.disabled = !selectedGiftVariantId;

      giftDebug('selectGift', { selectedGiftVariantId: selectedGiftVariantId });
    }

    function resetSelection() {
      selectedGiftVariantId = null;
      popupAdd.disabled = true;
      popupAdd.textContent = copy.addButtonLabel;
      for (var i = 0; i < giftOptions.length; i++) {
        giftOptions[i].classList.remove('selected');
      }
    }

    function preselectGiftByVariantId(variantId) {
      if (!variantId) {
        resetSelection();
        return;
      }
      var targetId = String(variantId);
      var foundOption = null;

      for (var i = 0; i < giftOptions.length; i++) {
        var opt = giftOptions[i];
        if (opt.getAttribute('data-variant-id') === targetId) {
          foundOption = opt;
          break;
        }
      }

      if (foundOption) {
        selectGift(foundOption);
      } else {
        resetSelection();
      }
    }

    function setSelectionLocked(locked) {
      for (var i = 0; i < giftOptions.length; i++) {
        var opt = giftOptions[i];
        if (locked) {
          opt.classList.add('is-locked');
          opt.setAttribute('aria-disabled', 'true');
        } else {
          opt.classList.remove('is-locked');
          opt.removeAttribute('aria-disabled');
        }
      }

      if (locked) {
        popupAdd.disabled = false;
        popupAdd.textContent = copy.changeGiftCtaLabel;
      } else {
        popupAdd.disabled = !selectedGiftVariantId;
        popupAdd.textContent = copy.addButtonLabel;
      }

      giftDebug('setSelectionLocked', { locked: locked });
    }

    function isSelectionLocked() {
      return giftOptions.length && giftOptions[0].classList.contains('is-locked');
    }

    function setSelectionConfirmed() {
      isConfirmedMode = true;
      for (var i = 0; i < giftOptions.length; i++) {
        var opt = giftOptions[i];
        opt.classList.add('is-confirmed');
        opt.classList.remove('is-locked');
        opt.setAttribute('aria-disabled', 'true');
      }
      if (popup) popup.style.setProperty('--vdb-confirmed-label', '"' + copy.addedBadge + '"');
      if (popupHeading) popupHeading.textContent = copy.confirmedHeading;
      popupAdd.disabled = false;
      popupAdd.textContent = copy.closeLabel;
    }

    function openPopup(preselectedVariantId, options) {
      if (isPopupVisible) return;
      isPopupVisible = true;

      options = options || {};
      var locked = !!options.locked;
      var confirmed = !!options.confirmed;

      if (preselectedVariantId) {
        preselectGiftByVariantId(preselectedVariantId);
      } else {
        resetSelection();
      }

      if (confirmed) {
        setSelectionConfirmed();
      } else {
        setSelectionLocked(locked);
      }

      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vdb-gift-popup-open');
      ctaButton.setAttribute('aria-expanded', 'true');

      giftDebug('openPopup', { preselectedVariantId: preselectedVariantId, locked: locked, confirmed: confirmed });
    }

    function closePopup() {
      if (!isPopupVisible) return;
      isPopupVisible = false;
      isConfirmedMode = false;
      for (var i = 0; i < giftOptions.length; i++) {
        giftOptions[i].classList.remove('is-confirmed');
      }
      if (popup) popup.style.removeProperty('--vdb-confirmed-label');
      if (popupHeading && originalPopupHeading) popupHeading.textContent = originalPopupHeading;
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vdb-gift-popup-open');
      ctaButton.setAttribute('aria-expanded', 'false');

      giftDebug('closePopup');
    }

    popupOverlay.addEventListener('click', closePopup);
    if (popupClose) {
      popupClose.addEventListener('click', closePopup);
    }
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && isPopupVisible) {
        closePopup();
      }
    });

    // CTA nel banner
    ctaButton.addEventListener('click', function () {
      if (ctaButton.disabled) return;

      if (hasGiftInCart && currentGiftVariantId) {
        isChangeMode = true;
        openPopup(currentGiftVariantId, { locked: true });
      } else {
        isChangeMode = false;
        var firstOption = giftOptions[0];
        var firstVariantId = firstOption ? firstOption.getAttribute('data-variant-id') : null;
        if (firstVariantId) {
          ctaButton.disabled = true;
          ctaButton.textContent = copy.addingLabel;
          ensureSingleGiftThenAdd(firstVariantId, function (success) {
            ctaButton.disabled = false;
            if (success) {
              fetchCartAndUpdate();
              openPopup(firstVariantId, { confirmed: true });
            } else {
              ctaButton.textContent = copy.ctaLabel;
              openPopup();
            }
          });
        } else {
          openPopup();
        }
      }

      giftDebug('ctaButton click', {
        hasGiftInCart: hasGiftInCart,
        currentGiftVariantId: currentGiftVariantId,
        isChangeMode: isChangeMode
      });
    });

    // Bottone "Aggiungi regalo" nel popup
    popupAdd.addEventListener('click', function () {
      if (isConfirmedMode) { closePopup(); return; }
      if (popupAdd.disabled) return;

      // Primo click in modalità "cambia": sblocca la scelta
      if (hasGiftInCart && isChangeMode && isSelectionLocked()) {
        setSelectionLocked(false);
        return;
      }

      if (!selectedGiftVariantId) return;

      popupAdd.disabled = true;
      popupAdd.textContent = copy.addingLabel;

      ensureSingleGiftThenAdd(selectedGiftVariantId, function (success) {
        popupAdd.disabled = false;
        popupAdd.textContent = success ? copy.addedLabel : copy.errorLabel;

        giftDebug('popupAdd result', { success: success, selectedGiftVariantId: selectedGiftVariantId });

        if (success) {
          var wasChangeMode = isChangeMode;
          isChangeMode = false;

          setTimeout(function () {
            popupAdd.textContent = copy.addButtonLabel;
          }, 1200);

          closePopup();

          // 🔁 NUOVO COMPORTAMENTO:
          // - Se siamo nel carrello (fase 2 o cambio in fase 3) → SEMPRE reload
          //   così compare subito il regalo nella lista
          if (isOnCartPage()) {
            try {
              window.location.reload();
            } catch (e) {}
          } else {
            // Fuori dal carrello basta riallineare il banner
            fetchCartAndUpdate();
          }

          return;
        } else {
          setTimeout(function () {
            popupAdd.textContent = copy.addButtonLabel;
          }, 1500);
        }
      });
    });

    function ensureSingleGiftThenAdd(variantIdToAdd, callback) {
      removeGiftFromCart(function () {
        addGiftToCart(variantIdToAdd, callback);
      });
    }

    // Rimuove tutti gli omaggi
    function removeGiftFromCart(done) {
      if (!giftVariantIds.length) {
        giftDebug('removeGiftFromCart → discovering gift variant ids via /cart.js');
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            var items = Array.isArray(cart.items) ? cart.items : [];
            for (var i = 0; i < items.length; i++) {
              var it = items[i];
              if (!itemIsGift(it)) continue;
              var vId = it.id || it.variant_id;
              if (vId) {
                var vIdStr = String(vId);
                if (giftVariantIds.indexOf(vIdStr) === -1) {
                  giftVariantIds.push(vIdStr);
                }
              }
            }
            doRemove();
          })
          .catch(function () {
            doRemove();
          });
      } else {
        doRemove();
      }

      function doRemove() {
        var updates = {};
        for (var i = 0; i < giftVariantIds.length; i++) {
          updates[giftVariantIds[i]] = 0;
        }

        giftDebug('removeGiftFromCart → updates', updates);

        if (!Object.keys(updates).length) {
          if (typeof done === 'function') done();
          return;
        }

        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart update failed');
            return response.json();
          })
          .then(function () {
            if (typeof done === 'function') done();
          })
          .catch(function () {
            if (typeof done === 'function') done();
          });
      }
    }

    // Aggiunge l’omaggio scelto
    function addGiftToCart(variantIdToAdd, callback) {
      giftDebug('addGiftToCart → adding', { variantIdToAdd: variantIdToAdd });

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantIdToAdd, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function (data) {
          giftDebug('addGiftToCart → success', data);

          var vId = data && (data.id || data.variant_id);
          if (vId) {
            var vIdStr = String(vId);
            if (giftVariantIds.indexOf(vIdStr) === -1) {
              giftVariantIds.push(vIdStr);
            }
          }

          if (typeof callback === 'function') callback(true);
          fetchCartAndUpdate();
        })
        .catch(function (err) {
          giftDebug('addGiftToCart → error', err);
          if (typeof callback === 'function') callback(false);
        });
    }

    function setBannerText(primary, secondary) {
      if (textEl) {
        textEl.textContent = primary;
      }
      if (subtextEl) {
        if (secondary !== subtextEl.textContent) {
          subtextEl.textContent = secondary;
          subtextEl.classList.remove('is-updated');
          void subtextEl.offsetWidth;
          subtextEl.classList.add('is-updated');
        }
      }
    }

    function triggerProgressAnimation() {
      wrapper.classList.remove('is-boost');
      void wrapper.offsetWidth;
      wrapper.classList.add('is-boost');
      setTimeout(function () {
        wrapper.classList.remove('is-boost');
      }, 600);
    }

    function formatMoney(cents) {
      cents = toNumber(cents);
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode || 'EUR'
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    // Cuore: aggiornamento fasi
    function updateBannerState(cart) {
      cart = cart || {};
      var totalPrice = toNumber(cart.total_price);
      var items = Array.isArray(cart.items) ? cart.items : [];

      giftDebug('updateBannerState → raw cart', cart);

      if (!enforcingSingleGift) {
        enforceSingleGiftInCart(cart, totalPrice);
      }

      var giftInCart = false;
      var i, item;

      currentGiftVariantId = null;

      for (i = 0; i < items.length; i++) {
        item = items[i];
        if (!item) continue;
        if (!itemIsGift(item)) continue;

        giftInCart = true;
        var vId = item.id || item.variant_id;
        if (vId) currentGiftVariantId = String(vId);
        break;
      }

      // Se sotto soglia ma con omaggio → rimuoviamo l’omaggio e poi riaggiorniamo (reload gestito dopo da fase 3→1)
      if (giftInCart && giftThreshold > 0 && totalPrice < giftThreshold && !autoRemoving) {
        giftDebug('updateBannerState → below threshold with gift, auto-removing', {
          totalPrice: totalPrice,
          giftThreshold: giftThreshold
        });

        autoRemoving = true;
        removeGiftFromCart(function () {
          autoRemoving = false;
          fetchCartAndUpdate();
        });
        return;
      }

      hasGiftInCart = giftInCart;

      if (progressBar) {
        progressBar.style.display = '';
      }

      var remaining = Math.max(giftThreshold - totalPrice, 0);
      var percentage = giftThreshold > 0 ? Math.min((totalPrice / giftThreshold) * 100, 100) : 0;
      var rounded = Math.round(percentage);

      progressFill.style.width = Math.min(Math.max(percentage, 0), 100) + '%';
      progressBar.setAttribute('aria-valuenow', String(rounded));

      if (giftInCart) {
        progressBar.setAttribute('aria-valuetext', copy.ariaRedeemed);
      } else if (giftThreshold > 0) {
        progressBar.setAttribute(
          'aria-valuetext',
          copy.ariaProgress
            .replace('%current%', formatMoney(totalPrice))
            .replace('%goal%', formatMoney(giftThreshold))
        );
      } else {
        progressBar.removeAttribute('aria-valuetext');
      }

      if (totalPrice !== lastTotalPrice) {
        triggerProgressAnimation();
      }
      lastTotalPrice = totalPrice;

      wrapper.classList.remove('is-glowing', 'is-reached', 'is-redeemed');

      var debugItems = items.map(function (it) {
        if (!it) return null;
        return {
          title: it.title,
          id: it.id,
          variant_id: it.variant_id,
          handle: it.handle,
          product_handle: it.product_handle,
          quantity: it.quantity,
          line_price: it.line_price
        };
      });

      var newPhase;

      if (giftInCart) {
        newPhase = 3;

        wrapper.classList.add('is-redeemed');

        if (progressBar) {
          progressBar.style.display = 'none';
        }

        ctaButton.style.display = 'inline-flex';
        ctaButton.disabled = false;
        ctaButton.textContent = copy.changeGiftCtaLabel;
        setBannerText(copy.redeemedTitle, copy.redeemedSubtext);

        giftDebug('BANNER STATE → PHASE 3 (redeemed)', {
          totalPrice: totalPrice,
          giftThreshold: giftThreshold,
          items: debugItems
        });

      } else if (giftThreshold > 0 && totalPrice >= giftThreshold) {
        newPhase = 2;

        wrapper.classList.add('is-reached');
        ctaButton.style.display = 'inline-flex';
        ctaButton.disabled = false;
        ctaButton.textContent = copy.ctaLabel;
        setBannerText(copy.unlockedTitle, copy.unlockedSubtext);

        if (percentage >= 80 && percentage < 100) {
          wrapper.classList.add('is-glowing');
        }

        giftDebug('BANNER STATE → PHASE 2 (unlocked, no gift)', {
          totalPrice: totalPrice,
          giftThreshold: giftThreshold,
          items: debugItems
        });

      } else {
        newPhase = 1;

        var primary = copy.progressTitle.replace('%remaining%', formatMoney(remaining));
        var secondary = copy.progressSubtext
          .replace('%current%', formatMoney(totalPrice))
          .replace('%goal%', formatMoney(giftThreshold));

        ctaButton.style.display = 'none';
        ctaButton.disabled = true;
        ctaButton.textContent = copy.ctaLabel;
        setBannerText(primary, secondary);

        if (percentage >= 80 && percentage < 100) {
          wrapper.classList.add('is-glowing');
        }

        giftDebug('BANNER STATE → PHASE 1 (below threshold)', {
          totalPrice: totalPrice,
          giftThreshold: giftThreshold,
          items: debugItems
        });
      }

      handlePhaseChange(newPhase, {
        totalPrice: totalPrice,
        giftThreshold: giftThreshold,
        hasGiftInCart: giftInCart
      });
    }

    function fetchCartAndUpdate() {
      var requestId = ++cartRequestId;
      giftDebug('fetchCartAndUpdate → /cart.js request', { requestId: requestId });

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (requestId < lastAppliedCartRequestId) {
            giftDebug('fetchCartAndUpdate → stale response ignored', { requestId: requestId });
            return;
          }
          lastAppliedCartRequestId = requestId;
          giftDebug('fetchCartAndUpdate → /cart.js response', {
            requestId: requestId,
            total_price: cart && cart.total_price
          });
          updateBannerState(cart);
        })
        .catch(function (err) {
          giftDebug('fetchCartAndUpdate → error', err);
        });
    }

    function handleCartEvent() {
      giftDebug('handleCartEvent → trigger fetchCartAndUpdate');
      fetchCartAndUpdate();
    }

    document.addEventListener('shopify:cart:updated', handleCartEvent);
    document.addEventListener('cart:updated', handleCartEvent);
    document.addEventListener('ajaxCart:afterUpdate', handleCartEvent);
    document.addEventListener('product:added', handleCartEvent);
    document.addEventListener('ajaxProduct:added', handleCartEvent);
    document.addEventListener('cart:change', handleCartEvent);
    document.addEventListener('cart:refresh', handleCartEvent);
    document.addEventListener('cart:requestComplete', handleCartEvent);

    hookNetworkForCartUpdates();

    // Primo render: leggiamo sempre il carrello reale
    fetchCartAndUpdate();
  }

  // Sei nella pagina /cart ?
  function isOnCartPage() {
    try {
      var path = window.location && window.location.pathname ? window.location.pathname : '';
      path = path.replace(/\/+$/, '');
      return path === '/cart';
    } catch (e) {
      return false;
    }
  }

  function parseCurrencyFormat(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }


// Testi del banner per la promo Calendario dell'Avvento / Santa Secret Stash
function resolveCopy(locale, marketCode) {
  var isItalian = (marketCode === 'IT') || (locale && locale.indexOf('it') === 0);

  if (isItalian) {
    // VERSIONE ITALIANA
    return {
      // Sotto soglia: il cliente non ha ancora raggiunto la soglia omaggio
      progressTitle:
        'Aggiungi %remaining% per sbloccare il regalo del Giorno (fino ad esaurimento)',
      progressSubtext:
        'Spesa attuale: %current% su %goal%',

      // Soglia raggiunta: regalo sbloccato ma non ancora aggiunto
      unlockedTitle: 'Regalo Sbloccato!',
      unlockedSubtext:
        'Clicca e scopri il vino del giorno in omaggio.',

      // Regalo già in carrello
      redeemedTitle: 'Vino del giorno aggiunto al carrello',
      redeemedSubtext:
        'Cin cin! Clicca qui se vuoi rivedere il tuo regalo.',

      // Label pulsanti
      ctaLabel: 'Il vino del Giorno è...',
      // Quando il regalo è già stato riscattato, il bottone diventa un “vedi” più che un “cambia”
      changeGiftCtaLabel: 'Regalo Aggiunto',
      addButtonLabel: 'Aggiungi il vino del giorno',
      addingLabel: 'Aggiungo il vino del giorno…',
      addedLabel: 'Vino del giorno aggiunto!',
      changingLabel: 'Aggiorno il regalo…',
      errorLabel: 'Riprova',

      // Accessibilità
      ariaProgress:
        'Spesa carrello %current% su %goal% per sbloccare il vino del giorno gratuito (fino esaurimento scorte)',
      ariaRedeemed:
        'Vino del giorno gratuito già aggiunto al carrello',

      // Avvisi
      unlockConfirmText:
        'Hai già riscattato il vino del giorno. Per cambiarlo devi prima sbloccarlo. Vuoi sbloccare e cambiare il regalo?',
      qtyWarning: 'È consentito un solo vino del giorno per ordine.',

      // Popup di conferma post-aggiunta
      confirmedHeading: 'Il tuo vino in omaggio è nel carrello!',
      closeLabel: 'Chiudi',
      addedBadge: '✓ Aggiunto'
    };
  }

  // VERSIONE INGLESE (tutti gli altri mercati)
  return {
    // Below threshold
    progressTitle:
      'Add %remaining% to unlock today’s Free wine',
    progressSubtext:
      'Current spend: %current% of %goal%',

    // Threshold reached
    unlockedTitle: 'Free Gift Unlocked!',
    unlockedSubtext:
      'Click to reveal and add Today’s Gift Wine',

    // Gift already in cart
    redeemedTitle: 'Today’s Free wine added',
    redeemedSubtext:
      'Cheers! Click here if you want to review your gift.',

    // Buttons
    ctaLabel: 'Click to Add',
    // When already redeemed, the CTA becomes “view” instead of “change”
    changeGiftCtaLabel: 'View today’s wine',
    addButtonLabel: 'Add today’s wine',
    addingLabel: 'Adding Free wine…',
    addedLabel: 'Free wine added!',
    changingLabel: 'Updating gift…',
    errorLabel: 'Try again',

    // Accessibility
    ariaProgress:
      'Cart spend %current% of %goal% to unlock today’s Free Wine Gift (while supplies last)',
    ariaRedeemed:
      'Today’s Free wine is already in your cart',

    // Warnings
    unlockConfirmText:
      "You have already redeemed today's Free wine. To change it you need to unlock it first. Do you want to unlock and change your gift?",
    qtyWarning: "Only 1 Free wine per order is allowed.",

    // Post-add confirmation popup
    confirmedHeading: "Your free wine is in the cart!",
    closeLabel: "Close",
    addedBadge: "✓ Added"
  };
}



  function detectCurrency() {
    if (window.Shopify && Shopify.currency) {
      return Shopify.currency.active || Shopify.currency.shopCurrency || 'EUR';
    }
    return 'EUR';
  }

  function debounce(fn, wait) {
    var timeoutId;
    return function () {
      var args = arguments;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function toNumber(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      var parsed = parseFloat(value);
      if (!isNaN(parsed)) {
        return Math.round(parsed);
      }
    }
    if (value && typeof value === 'object' && typeof value.valueOf === 'function') {
      var v = value.valueOf();
      if (typeof v === 'number') return v;
      if (typeof v === 'string' && !isNaN(parseFloat(v))) {
        return Math.round(parseFloat(v));
      }
    }
    return 0;
  }
})();